import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import FileUploadField from "../../../components/Fields/FileUploadField";
import { FormConfig } from "../../../components/Fields/Types";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import BillOfMaterialItemModel from "../../../models/BillOfMaterialItemModel";
import FileCreateResultModel from "../../../models/FileCreateResultModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface IProps extends PopupProps {
    bomItem: BillOfMaterialItemModel
}

interface BillOfMaterialItemFileCreateModel {
    billOfMaterialItemId: number,
    fileName?: string
    fileResult?: FileCreateResultModel

}

const AddReferencePicturePopup: React.FC<IProps> = ({ show, onHide, bomItem }) => {
    const [file, setFile] = useState<File>();
    const [serverErrors, setServerErrors] = useState<DataResult<BillOfMaterialItemFileCreateModel>>({ isSuccesful: true, messages: [], data: undefined });

    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<BillOfMaterialItemFileCreateModel>({
        billOfMaterialItemId: bomItem.id,
    });

    function submit() {
        if (formData && file) {
            DataService
                .createFile(file)
                .then(fileResponse => {
                    handleResult(fileResponse);
                    if (fileResponse.isSuccesful === true && fileResponse.data) {
                        formData.fileResult = fileResponse.data;
                        DataService
                            .create<BillOfMaterialItemFileCreateModel>(`api/v1/BillOfMaterialItemFiles`, formData)
                            .then(response => {
                                handleResult(response);
                                setServerErrors(response);
                                if (response.isSuccesful === true) {
                                    onHide();
                                }
                            })
                            .catch(e => handleException(e));
                    }
                    else {
                        handleResult(fileResponse);
                    }
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string | File): void {
        if (name === 'fileName' && typeof (value) === 'object') {
            setFile(value);
            formData.fileName = value.name;
        }
        else {
            formData[name] = value;
        }
        setFormData(formData);
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'fileName', label: 'File', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add reference picture'} >
            <Popup.Body>
                <FileUploadField {...getFieldProps('fileName')} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddReferencePicturePopup;